export default __webpack_public_path__ + "static/media/28.b485ea1f.webp";